<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid="">
    
        <b-row v-if="titulo !== undefined" class="titulo">
            <b-col class="seccionTitulo"> 
                <span v-if="icono !== undefined"><font-awesome-icon :icon="icono" /></span>
                <span>{{titulo}}</span>
            </b-col>
            <b-col class="seccionCodigo">
                <div v-if="codigoTitulo !== undefined">{{codigoTitulo}}</div>
            </b-col>
        </b-row>

        <b-row v-if="subTitulo !== undefined">
            <b-col class="subtitulos">
                {{subTitulo}}
            </b-col>
        </b-row>

        <b-row v-if="filtros !== undefined && filtros !== null" align-v="center" align-h="start">
            <b-col cols="4" v-for="elemento in filtros" :key="elemento">
                <div :is="elemento" :data="elemento" v-if="elemento !== undefined" 
                @_setearValor="setearValor" :valoresFiltros="valoresFiltros"  :key="elemento"
                ></div>
            </b-col>
        </b-row>

        <b-row v-if="filtros !== undefined && filtros !== null" align-v="center" align-h="end">
            <b-col align="right">
                <b-button v-b-tooltip.hover   variant="outline-success"  @click="funcionBuscar()" >
                    Buscar
                </b-button>
            </b-col>
        </b-row>

        <div class="mt-2 col-md-12"></div>

        <b-row v-if="contenido !== undefined && contenido !== null" >
            <b-col cols="12" v-for="elemento in contenido" :key="elemento.id">
                <br/>
                <div :is="elemento.component" :contenidoTabla="elemento" 
                v-if="elemento.component !== undefined && elemento !== null">                 
                </div>
                <br/>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>
import Header from "../Header.vue";

export default {
    name: "tablasComponente",
    components: {
        Header
    },
    props: {
        icono: String,
        titulo: String,
        subTitulo: String,
        codigoTitulo: String,
        filtros: Array,
        contenido: Array,

    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        paginaActual: 1,
        registrosPorPagina: 10,
        valoresFiltros : {}
    }),
    watch: {},
    computed: {},
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    mounted() {},
    methods: {
        funcionBuscar() {
            this.$emit("_funcionBuscar", this.valoresFiltros);
            //reiniciamos la pagina actual por que si no se queda con esta en memoria y marca errores
            //cuando hay pestañas que no tienen esa pagina
            this.paginaActual = 1;
        },
        setearValor(valor){
            /* recibe json , propiedad y valor */
            this.valoresFiltros[valor.propiedad] = valor.valor;

        }
        
    },

}
</script>
